/* eslint-disable */
import React from 'react';
import { Ico } from './ShellIcons';
import r from './rail.module.css';

// ============================================================
// The rail's two big selectors (CLB-064, prototype v2 approved 11.10):
//   LineToggle — the line (Sun / Optic): icon + label + count, unmistakable,
//                at the start of the SCOPE box.
//   YearTabs   — equal-width year tabs: the year (14 px), its count, and a
//                4 px bar whose length is the year's size against the
//                biggest year (amber on the selected one), so the years can
//                be compared at a glance (David: "the years are important
//                for comparison"). "All" closes the row.
// Options: [{ value, label, count?, icon?, title?, disabled? }].
// ============================================================

const fmt = (n) => (n == null ? '' : Number(n).toLocaleString('en-US'));

export function LineToggle({ field }) {
  return (
    <div className={r.line} data-line-toggle role="group" aria-label={field.ariaLabel || field.axis || 'Line'}>
      {field.options.map((o) => {
        const on = field.value === o.value;
        return (
          <button key={String(o.value)} type="button" className={on ? r.on : ''} aria-pressed={on} disabled={o.disabled}
            title={o.title || `${o.label}${o.count != null ? ` · ${fmt(o.count)}` : ''}`}
            onClick={(e) => { e.stopPropagation(); if (!on) field.onChange(o.value); }}>
            {o.icon ? <Ico name={o.icon} /> : null}
            <span className={r.wl} data-wl>{o.label}</span>
            {o.count != null ? <span className={r.k} data-k>{fmt(o.count)}</span> : null}
          </button>
        );
      })}
    </div>
  );
}

// `multi` (Compare years): the value is a Set — each tab adds or removes its
// year (a check mark says it is in); `baseMode` puts "set base" / "base" under
// each tab in place of the size bar (onBase picks the year every other one is
// measured against).
export function YearTabs({ field }) {
  const years = field.options.filter((o) => o.value !== 'all');
  const all = field.multi ? null : field.options.find((o) => o.value === 'all');
  const max = Math.max(1, ...years.map((o) => o.count || 0));
  const tab = (o, isAll) => {
    const on = field.multi ? field.value.has(o.value) : field.value === o.value;
    if (field.multi) {
      const isBase = field.baseMode && field.base === o.value;
      return (
        <div key={String(o.value)} className={`${r.yr} ${r.multi} ${on ? r.on : ''} ${o.open ? r.yopen : ''}`} role="group" aria-label={o.label}>
          <button type="button" className={r.yt} aria-pressed={on} title={o.title} onClick={(e) => { e.stopPropagation(); field.onChange(o.value); }}>
            <span className={r.tk}><Ico name="check" /></span><span className={r.yl}>{o.label}</span>{o.count != null ? <span className={r.k} data-k>{fmt(o.count)}</span> : null}
          </button>
          {field.baseMode
            ? <button type="button" className={`${r.ybs} ${isBase ? r.is : ''}`} aria-pressed={isBase} title={`Measure every other year against ${o.label}`} onClick={(e) => { e.stopPropagation(); field.onBase(o.value); }}>{isBase ? 'base' : 'set base'}</button>
            : <span className={r.yb}><i style={{ width: `${Math.round(((o.count || 0) / max) * 100)}%` }} /></span>}
        </div>
      );
    }
    const pct = isAll ? 100 : Math.round(((o.count || 0) / max) * 100);
    const empty = !isAll && !o.count;
    return (
      <button key={String(o.value)} type="button" className={`${r.yr} ${on ? r.on : ''} ${isAll ? r.all : ''} ${empty ? r.empty : ''}`}
        aria-pressed={on} title={o.title || `${o.label} · ${fmt(o.count || 0)}`}
        onClick={(e) => { e.stopPropagation(); if (!on) field.onChange(o.value); }}>
        <span className={r.yt}><span className={r.yl}>{o.label}</span>{o.count != null ? <span className={r.k} data-k>{o.count ? fmt(o.count) : (field.loading ? '…' : '—')}</span> : null}</span>
        <span className={r.yb}><i style={{ width: `${pct}%` }} /></span>
      </button>
    );
  };
  return (
    <div className={r.yrs} role="group" aria-label={field.ariaLabel || 'Year'}>
      {years.map((o) => tab(o, false))}
      {all ? tab(all, true) : null}
    </div>
  );
}
